<template>
  <div class="d-flex justify-space-between mt-2" data-testid="voicemail-detail-msg-header">
    <div class="d-flex justify-space-between" v-if="displayCaller" data-testid="voicemail-detail-msg-caller">
      <div class="d-flex justify-start">
        <v-list-item-avatar data-testid="voicemail-detail-avatar">
          <v-img
            v-if="displayCaller.hasImage"
            :src="displayCaller.imageUrl"
            :alt="displayCaller.name"
            data-testid="voicemail-detail-contactImage"
          ></v-img>
          <v-img
            v-else
            src="/default_picture_profile.png"
            :alt="displayCaller.name"
            data-testid="voicemail-detail-defaultPicture"
          ></v-img>
        </v-list-item-avatar>
        <div class="ml-2 mt-2" align="left" data-testid="voicemail-detail-msg-number">
          <span><msg-caller-number :voicemail="voicemail" /></span>
        </div>
      </div>
    </div>
    <div class="mt-2" data-testid="voicemail-detail-msg-time" align="right" style="width: 100%;">
      <div class="d-flex flex-row-reverse">
        <actions
          v-if="!isOnMobile"
          :voicemail="voicemail"
          @xfer-msg="$emit('xfer-msg', $event)"
          @del-msg="$emit('del-msg', $event)"
          @move-to-custom-folder="$emit('move-to-custom-folder', $event)"
          @remove-from-custom-folder="$emit('remove-from-custom-folder', $event)"
          data-testid="voicemail-detail-actions"
        />
        <span class="text-caption font-weight-light primary-text mt-2"
          data-testid="voicemail-detail-time"
          style="width: 150px;"
        >
          {{ time }}
        </span>
      </div>
      <div class="d-flex justify-end mt-1" v-if="voicemail.isCustomFolder && isOnMobile">
        <v-icon class="mr-1" small>mdi-folder</v-icon>
        <span class="text-caption font-weight-light" data-testid="voicemail-folder-name">{{ folderName }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MsgCallerNumber from '@/components/voicemails/msg_caller_number'
import Actions from '@/components/voicemails/msg_detail/msg_header/actions'
import { format } from 'date-fns'

export default {
  name: 'voicemail-detail-msg-header',
  components: { MsgCallerNumber, Actions },
  props: {
    voicemail: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      tableHeight: '100vh - 25px - 55px'
    }
  },
  computed: {
    ...mapGetters({
      canWriteVMsg: 'permissions/vmailsWrite',
      phoneNumbers: 'contacts/phoneNumbers/phoneNumbers'
    }),
    contact () {
      return this.phoneNumbers?.find((phone) => parseInt(phone.phoneNumber) === parseInt(this.voicemail?.callerNum))
    },
    displayCaller () {
      if (this.contact) {
        return this.contact
      } else {
        return {
          hasImage: false,
          name: this.voicemail?.callerName,
          imageUrl: null,
          phoneNumber: this.voicemail?.callerNum
        }
      }
    },
    time () {
      const date = new Date(this.voicemail?.time)
      return format(date, 'd MMM yyyy h:mm aaa')
    },
    folderName () {
      return this.voicemail?.customFolder
    },
    isOnMobile () {
      return this.$vuetify.breakpoint.mobile
    },
    isDarkMode () {
      return this.$vuetify.theme.dark
    }
  }
}
</script>

<style scoped>
</style>
